export default "__VITE_ASSET__CfPl3ujS__"